import refapLogo from "../imgs/logo.svg";
import kargozaranLogo from "../imgs/kargozaran.svg";



export const API_URL = "https://kargozaran-api.sanaap.co";
export const FROM_KARGOZAR = true



export const customerList = [
    {
        name:"kargozaran",
        logo:kargozaranLogo,
    },
    {
        name:"refap",
        logo:refapLogo,
    },

]

export const currentCustomer = customerList.filter(it=> it.name == "kargozaran")[0];
